import { useContext } from 'react'
import invariant from 'tiny-invariant'

import { TherapistCartContext } from '@/src/domains/cart/contexts/TherapistCart.context'

export const useTherapistCart = () => {
  const therapistCart = useContext(TherapistCartContext)

  invariant(therapistCart, 'useTherapistCart must be used within a TherapistCartProvider')

  return therapistCart
}
